export default "__VITE_ASSET__CNyxRKpX__"